export default {
  name: 'show-modal-instructions-mixin',
  methods: {
    showModalInstructions(key) {
      return localStorage.getItem(key) === '1';
    }
  }
}